/**
 * Onboarding opschonen — de te-accorderen onboarding-documenten (Deel C).
 *
 * Single source of truth voor de org-brede akkoord-documenten: de `sleutel`
 * (stabiele key in de DB + URL), de `titel` (label) en de `veldId` die in de
 * standaard-template-seed bij het bijbehorende akkoord-checkbox-veld hoort.
 *
 * Gebruikt door:
 *  - de API (seed van de 5 rijen + sleutel-validatie + lijst/preview)
 *  - de backoffice-instelling (HR koppelt per sleutel een PDF)
 *  - de portal (mapt een akkoord-veld-id → sleutel voor de "Bekijk document"-knop)
 *
 * Het contract (JURIDISCH) zit hier bewust NIET in: dat is een per-onboarding
 * gegenereerd document dat de kandidaat in de aparte teken-flow inziet/tekent.
 */
export const ONBOARDING_AKKOORD_DOCUMENTEN = [
  { sleutel: 'huisregels', titel: 'Huisregels', veldId: 'akkoordHuisregels' },
  { sleutel: 'privacy', titel: 'Privacy-statement', veldId: 'akkoordPrivacy' },
  { sleutel: 'reglement', titel: 'Bedrijfsreglement', veldId: 'akkoordReglement' },
  { sleutel: 'veiligheid', titel: 'Veiligheidsinstructies', veldId: 'akkoordVeiligheid' },
  { sleutel: 'it_beleid', titel: 'IT- en privacy-beleid', veldId: 'akkoord_it_policy' },
] as const

export type OnboardingAkkoordSleutel =
  (typeof ONBOARDING_AKKOORD_DOCUMENTEN)[number]['sleutel']

export const ONBOARDING_AKKOORD_SLEUTELS: readonly string[] =
  ONBOARDING_AKKOORD_DOCUMENTEN.map((d) => d.sleutel)

/** Map een akkoord-veld-id (uit het formulier-schema) → akkoord-sleutel. */
export function akkoordSleutelVoorVeld(veldId: string): OnboardingAkkoordSleutel | null {
  const match = ONBOARDING_AKKOORD_DOCUMENTEN.find((d) => d.veldId === veldId)
  return match ? match.sleutel : null
}

/** API-respons per akkoord-document (lijst + beschikbaarheid). */
export interface OnboardingAkkoordDocumentDTO {
  sleutel: string
  titel: string
  veldId: string
  /** True wanneer er een PDF gekoppeld is (anders geen preview-knop tonen). */
  beschikbaar: boolean
  /** Bestandsnaam van de gekoppelde PDF, indien aanwezig. */
  bestandsnaam: string | null
}
